function setUtmParams() {
    const searchParams = new URLSearchParams(location.search);

    for (const [key, value] of searchParams) {
        if (key.includes('utm_source') || key.includes('utm_medium')) {
            sessionStorage.setItem(key, value);
        }
    }
}

window.addEventListener('load', setUtmParams);
